import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
} from "@mui/material";
import grohe from "../../../src/clientlogo/index_grohe_logo.jpg";
import americanStandard from "../../../src/clientlogo/index_as_logo.gif";
import bgImg from "../../../src/SliderImage/4.jpg";
import Sidebar from "./Sidebar";
import { useDrawer } from "../../DrawerContext";

const MainLayout = ({ children, title, topbar = true, disableMenu=false, disableScroll=false }) => {
  const navigate = useNavigate();
  const { drawerVisible } = useDrawer();
  const currentDrawerWidth = drawerVisible ? "240px" : "80px";

  const clientLogos = [
    { src: grohe, alt: "Grohe" },
    { src: americanStandard, alt: "American Standard" },
  ];

  return (
    <div>
      <div className="absolute inset-0 -z-20">
        <img src={bgImg} className="w-full h-full object-cover fixed" />
      </div>

      {topbar &&
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            background: "rgba(4, 18, 31, 0.70)",
            backdropFilter: "blur(16px)",
            WebkitBackdropFilter: "blur(16px)",
            height: "68px",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 4px 30px rgba(0, 0, 0, 0.15)",
            ml: currentDrawerWidth,
            width: `calc(100% - ${currentDrawerWidth})`,
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          <Toolbar
            sx={{
              padding: 0,
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", flex: 1 }}>

              <div
                className="flex gap-6 items-center ml-4"
                onClick={() => navigate("/admin/home")}
              >
                {clientLogos.map((logo, i) => (
                  <div
                    key={i}
                    className="p-2 shadow-md flex items-center justify-center"
                    style={{
                      backgroundColor: i === 0 ? "#111F39" : "#fff",
                      borderRadius: "2px",
                    }}
                  >
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="w-12 h-8 object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>

            <div
              style={{ flexGrow: 1, display: "flex", justifyContent: "center" }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "0.75rem",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  background: "linear-gradient(90deg, #0f172a 0%, #1e293b 100%)",
                  px: 4,
                  py: 1,
                  borderRadius: "50px",
                  border: "1px solid #0288d1",
                  boxShadow: "0px 0px 15px rgba(2, 136, 209, 0.3)",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "180px",
                  position: "relative",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: "50px",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
                    pointerEvents: "none",
                  },
                }}
              >
                {title || "Admin Panel"}
              </Typography>
            </div>

            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <div className="flex px-2 items-center gap-2 bg-white p-1 rounded-sm shadow-sm">
                <p className="text-orange-600 px-2 py-1 text-sm font-bold">
                  LI<span className="text-base">X</span>IL
                </p>
              </div>
            </div>
          </Toolbar>
        </AppBar>
      }

      {/* Sidebar */}
      <Sidebar disableMenu={disableMenu}/>

      {/* Content */}
      <Box
        sx={{
          ml: currentDrawerWidth,
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          mt: topbar ? "64px" : "0px",
          p: topbar ? "15px" : "0px",
          minHeight: disableScroll ? "auto" : "100vh",
          height: disableScroll ? (topbar ? "calc(100vh - 64px)" : "100vh") : "auto",
          overflow: disableScroll ? "hidden" : "visible",
          display: disableScroll ? "flex" : "block",
          flexDirection: disableScroll ? "column" : "row",
          boxSizing: "border-box",
        }}
      >
        {children}
      </Box>
    </div>
  );
};

export default MainLayout;
